import { render, staticRenderFns } from "./Envs.vue?vue&type=template&id=3579009b"
import script from "./Envs.vue?vue&type=script&lang=js"
export * from "./Envs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports